export const publicPartnersFragment = `
  "publicPartners": *[_type == "partnerIndex" && _id =='partnerIndex'] {
    partners[]->{
      commercetoolsKey,
      name,
      'slug': slug.current
    }
  }
`;
